import { makeStyles } from '@material-ui/core';

export const compraProdutoItemStyles = makeStyles({
  produtoNomeContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  containerInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonRemoveContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export const compraProdutoListStyles = makeStyles({
  buttonAdicionarProduto: {
    color: '#53c4e6',
    fontSize: 15,
    marginTop: 8,
  },
});
